import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Footer from '~app/features/app/components/Footer';
import MainHeader from '~app/features/app/components/MainHeader';
import ToolBar from '~app/features/sideBar/components/ToolBar';
import Canvas from '~app/features/canvas/components/Canvas';
import Landing from '~app/features/landing/components/Landing';
import GradingTool from '~app/features/gradingTool/components/GradingTool';
import SupportingInfo from '~app/features/supportingInfo/SupportingInfo';

function App() {
  document.title = 'Model Builder: HHMI BioInteractive';
  const location = useLocation();
  return (
    <div className="Layout__app">
      <Switch>
        <Route exact path="/">
          <MainHeader hasMenu={false} hasExit={false} />
          <div className="Layout__main">
            <Landing />
          </div>
        </Route>
        <Route exact path="/canvas">
          <MainHeader hasMenu={true} hasExit={false} />
          <div role="main" className="Layout__main">
            <ToolBar />
            <Canvas />
          </div>
        </Route>
        <Route exact path="/grading-tool">
          <MainHeader hasMenu={false} hasExitToHome={true} />
          <div className="Layout__main">
            <GradingTool />
          </div>
        </Route>
        <Route exact path="/info">
          <MainHeader hasMenu={false} hasExit={true} />
          <div tabIndex="0" className="Layout__main">
            <SupportingInfo />
          </div>
        </Route>
        <Route path="*">
          <MainHeader hasMenu={false} hasExit={false} />
          <div className="Layout__main">
            <h3>
              Page not found (location: <code>{location.pathname}</code>)
            </h3>
          </div>
        </Route>
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
